@if (enabled) {
<section class="banner-admin" aria-labelledby="banner-admin-heading">
  <div>
    <div class="banner-admin-header">
      <h3 id="banner-admin-heading">{{ translationService.translate('bannerManagementText') }}</h3>
      <button mat-flat-button type="button" class="btn-clear" [disabled]="busy" (click)="openEditor()">
        {{ translationService.translate('bannerCreateText') }}
      </button>
    </div>
    <p>{{ translationService.translate('bannerGlobalHelpText') }}</p>

    @if (loading) {
    <mat-spinner diameter="24" [attr.aria-label]="translationService.translate('bannerLoadingText')"></mat-spinner>
    } @else if (loadFailed) {
    <p class="banner-error" role="alert">
      {{ translationService.translate('bannerLoadErrorText') }}
      <button mat-button type="button" (click)="loadBanners()">{{ translationService.translate('bannerRetryText') }}</button>
    </p>
    } @else if (!banners.length) {
    <p>{{ translationService.translate('bannerEmptyText') }}</p>
    } @else {
    <p class="hint">{{ timezoneText }}</p>
    <div class="banner-table">
      <table mat-table [dataSource]="banners" [attr.aria-label]="translationService.translate('bannerManagementText')">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>{{ translationService.translate('bannerTitleText') }}</th>
          <td mat-cell *matCellDef="let banner" class="banner-title">{{ banner.title }}</td>
        </ng-container>
        <ng-container matColumnDef="start">
          <th mat-header-cell *matHeaderCellDef>{{ translationService.translate('bannerStartText') }}</th>
          <td mat-cell *matCellDef="let banner">{{ bannerService.formatDateTime(banner.startAt) }}</td>
        </ng-container>
        <ng-container matColumnDef="end">
          <th mat-header-cell *matHeaderCellDef>{{ translationService.translate('bannerEndText') }}</th>
          <td mat-cell *matCellDef="let banner">{{ bannerService.formatDateTime(banner.endAt) }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ translationService.translate('bannerStatusText') }}</th>
          <td mat-cell *matCellDef="let banner">{{ translationService.translate(statusKey(banner)) }}</td>
        </ng-container>
        <ng-container matColumnDef="template">
          <th mat-header-cell *matHeaderCellDef>{{ translationService.translate('bannerTemplateColumnText') }}</th>
          <td mat-cell *matCellDef="let banner">{{ translationService.translate(banner.isTemplate ? 'yesText' : 'noText') }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ translationService.translate('bannerActionsText') }}</th>
          <td mat-cell *matCellDef="let banner" class="banner-actions">
            <button
              mat-icon-button
              type="button"
              [disabled]="busy"
              [attr.aria-label]="translationService.translate('bannerActionsText') + ': ' + banner.title"
              [matMenuTriggerFor]="actions"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actions="matMenu">
              <button mat-menu-item type="button" [disabled]="busy || !enabled" (click)="openEditor(banner.id)">
                <mat-icon>edit</mat-icon>
                {{ translationService.translate('bannerEditText') }}
              </button>
              <button mat-menu-item type="button" [disabled]="busy || !enabled" (click)="toggleActive(banner)">
                <mat-icon>{{ banner.isActive ? 'visibility_off' : 'visibility' }}</mat-icon>
                {{ translationService.translate(banner.isActive ? 'bannerDeactivateText' : 'bannerActivateText') }}
              </button>
              <button mat-menu-item type="button" [disabled]="busy || !enabled" (click)="deleteBanner(banner)">
                <mat-icon>delete</mat-icon>
                {{ translationService.translate('bannerDeleteText') }}
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
    </div>
    }
  </div>
</section>
}
